module.exports = { src: __webpack_public_path__ + "media/illustration-truck-home.da7e4866.webp", width: 169, height: 120 };